import ShellLayout from '@playground/features/shell/ShellLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app')({
  component: ShellLayout,
})
